import axios from './axios'
import qs from "qs";

function service() {

    function fetchUserTargetValues(id, data = {}) {
        return axios.get(`users/${id}/target-values/matrix`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function saveUserTargetValues(id, data = {}) {
        return axios.post(`users/${id}/target-values/save`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        fetchUserTargetValues,
        saveUserTargetValues
    }
}

export default service
